export function FriendsCard({
  kidsOnline = [],
  friendsOnline = [],
  myFriends = [],
  friendRequests = [],
  pendingRequests = [],
  defaultProfile,
  onSendRequest,
  onAcceptRequest,
  onDenyRequest,
  onRemoveFriend,
  onMessageFriend,
  currentUser,
  unreadMap,
}) {
  return (
    <div>
      {/* 好友邀請通知 */}
      {friendRequests.length > 0 && (
        <div className="friend-requests-panel">
          <h4>Friend Requests</h4>
          <ul className="request-list">
            {friendRequests.map(req => (
              <li key={req.fromUid}>
                <img src={req.avatar || defaultProfile} className="friend-thumbnail-icon" alt="" />
                <b>{req.fromName || req.fromUid.slice(-4)}</b>
                <button className="accept-btn" onClick={() => onAcceptRequest(req)}>Accept</button>
                <button className="deny-btn" onClick={() => onDenyRequest(req)}>Deny</button>
              </li>
            ))}
          </ul>
        </div>
      )}

      {/* Kids Online 區塊 */}
      <div className="kids-online-panel">
        <h4>Kids Online</h4>
        {(!kidsOnline || kidsOnline.length === 0) ? (
          <div style={{ padding: 12, color: "#bbb" }}>No kids online</div>
        ) : (
          <ul className="kid-list">
            {kidsOnline.map(k => {
              const pending = pendingRequests.some(r => r.uid === k.uid);
              const isSelf = k.uid === currentUser?.uid;
              const isFriend = myFriends.some(f => f.uid === k.uid);

              return (
                <li key={k.uid}>
                  <img src={k.avatar || defaultProfile} className="friend-thumbnail-icon" alt="" />
                  {k.firstName || (k.uid && k.uid.slice(-4))}
                  {!isSelf && !isFriend && !pending && (
                    <button className="add-friend-btn" onClick={() => onSendRequest(k)}>+ Invite</button>
                  )}
                  {pending && <span className="pending-badge">Pending</span>}
                </li>
              );
            })}
          </ul>
        )}
      </div>

      {/* 所有好友 All Friends 區塊 */}
      <div className="all-friends-panel">
        <h4>All Friends</h4>
        {(!myFriends || myFriends.length === 0) ? (
          <div style={{ padding: 12, color: "#bbb" }}>You have no friends yet</div>
        ) : (
          <ul className="friend-list">
            {myFriends.map(f => (
              <li key={f.uid}>
                <img src={f.avatar || defaultProfile} className="friend-thumbnail-icon" alt="" />
                {f.firstName || (f.uid && f.uid.slice(-4))}
               <button
                 className="message-btn"
                title="Send direct message"
                aria-label="Send direct message"
                onClick={() => onMessageFriend(f)}
              > ✉
              {unreadMap && unreadMap[f.uid] && (
              <span className="unread-badge"></span>
              )}
              </button>
                <button className="remove-btn" onClick={() => onRemoveFriend(f)}>🗑</button>
              </li>
            ))}
          </ul>
        )}
      </div>
    </div>
  );
}
